import React from 'react';
import { EmailVariablesViewModel } from './email-variables.viewmodel';
import DefaultButton from '../default-button/default-button';
import { EMAIL_VARIABLES_VIEW_LIST_TEXT, EMAIL_VARIABLES_VIEW_LIST_TITLE_TEXT } from './email-variables.texts';
import { observer } from 'mobx-react';

interface IProps {
    vm: EmailVariablesViewModel;
}

export const EmailVariablesSectionPresentation = observer(({ vm }: IProps): JSX.Element => {
    return (
        <div className='email-variables-section'>
            <p className='email-variables-section__title'>{vm.intl.formatMessage(EMAIL_VARIABLES_VIEW_LIST_TITLE_TEXT)}</p>
            <DefaultButton
                text={vm.intl.formatMessage(EMAIL_VARIABLES_VIEW_LIST_TEXT)}
                onClick={vm.openPopup}
                disabled={!vm.isVariablesFormHidden()}
            />
        </div>
    );
});